import {BaseEntity} from "../common/base-entity";

export class Login extends BaseEntity {
  public loginId: string;
  public firstName : string;
  public lastName : string;
  public password: string;
  public retypePassword: string;
  public rememberMe: boolean;
  public reCaptchaToken: string;
  constructor(login? : Login) {
    super (login) ;
  }
}
